export const bluePercentage = {
  min: 0,
  max: 100,
  base: 25
};

export const redPercentage = {
  min: 0,
  max: 100,
  base: 25
};

export const yellowPercentage = {
  min: 0,
  max: 100,
  base: 25
};

export const colorPercentage = {
  min: 0,
  max: 100,
  base: 20
};

export const lineBase = {
  min: 1,
  max: 15,
  base: 6
};

export const mutedPercentage = {
  min: 0,
  max: 100,
  base: 20
};
